import ServiceRefreshment from '@/views/ServiceRefreshment/index.vue'

const ServiceRefreshmentRouter = {
  path: '/service-refreshment',
  name: 'ServiceRefreshment',
  component: ServiceRefreshment,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default ServiceRefreshmentRouter
